<template>
  <div>
    <div v-if="error">{{error}}</div>
    <image-uploader
      :id="'fileInput'+flat"
      className="image-uploader"
      :quality="0.9"
      :autoRotate="true"
      :preview="false"
      outputFormat="blob"
      @input="onPicked"
    >
      <label :for="'fileInput'+flat" slot="upload-label" :ref="'fileLabel'+flat">
      </label>
    </image-uploader>
    <v-btn slot="upload-label" flat v-if="!file" @click="pickFile">
      <v-icon>image</v-icon>
    </v-btn>
    <v-btn flat v-if="file" @click="upload" :disabled="!file">
      <v-icon>cloud_upload</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { Logger } from '@aws-amplify/core';
import Storage from '@aws-amplify/storage';
import EventBus from '../../events/EventBus';
export default {
  name: 'IpWayPhotoPiker',
  props: ['flat'],
  data() {
    return {
      logger: {},
      photoUrl: '',
      file: null,
      error: ''
    };
  },
  mounted() {
    this.logger = new Logger(this.$options.name);

  },
  methods: {
    upload: function() {
      this.$store
        .dispatch('flats/getUploadUrl', this.flat)
        .then(url => {
          console.log(url);
          this.$http.put(url, this.file).then(reply => {
            console.log(reply);
            this.completeFileUpload();
          });
        });
    },
    pickFile: function() {
      this.$refs['fileLabel'+this.flat].click();
    },
    onPicked: function(evt) {
      console.log(evt);
      this.file = evt;
      const reader = new FileReader();
      reader.onload = e => {
        const target = e.target;
        this.photoUrl = target.result;
        this.$emit('preview', this.photoUrl);
      };
      reader.readAsDataURL(this.file);
      

    },
    completeFileUpload: function() {
      this.photoUrl = '';
      this.file = null;
      //EventBus.$emit('fileUpload');
    },
    setError: function(e) {
      this.error = e.message || e;
      this.logger.error(this.error);
    }
  }
};
</script>
<style >
.image-uploader {
  display: none;
}
</style>